/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import PatientPanel from './PatientPanel/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content/TaskOverview/Content/Actions",
  viewNo,
  viewPatientPanel
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={viewNo}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={viewPatientPanel}>
<PatientPanel
  viewPath={`${viewPath}/PatientPanel`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}